import styled from 'styled-components';

import { adSlotConfig } from '../../ad-slot-config';
import { useDefineSlot } from '../../hooks/use-define-slot';

const AdContainer = styled.div`
  min-height: 100px;
  max-height: 150px;
  margin: 0 auto;
`;

export const DisplayAdLoginRectangle: React.FC<{ refresh: boolean }> = ({
  refresh,
}) => {
  const slotConfig = adSlotConfig.Login.Rectangle;
  useDefineSlot({ ...slotConfig, refresh });

  return <AdContainer id={slotConfig.id} />;
};
